import React from 'react';
import {PageProps} from '.';

export const CoreDynamicPagesContext = React.createContext<{
  page?: PageProps;
  parentPage?: PageProps;
}>({});
